<script setup>
import {
  ref, watch, nextTick, inject, computed,
} from 'vue';
import ModalSimple from '@/components/ModalSimple.vue';
import Spinner from '@/components/Spinner.vue';
import SelectorColumna from './SelectorColumna.vue';

const I18n = inject('I18n');

const props = defineProps({
  modelValue: { type: Boolean, required: true },
  titulo: { type: String, default: undefined },
  loading: { type: Boolean, default: false },
  columnas: { type: Array, default: () => [] },
  puedeAceptar: { type: Boolean, default: false },
  puedeLimpiar: { type: Boolean, default: false },
  nivelModal: { type: Number, default: 2 },
});

const emit = defineEmits(['update:modelValue', 'seleccionar', 'limpiar', 'aceptar']);

const tituloModal = computed(() => {
  if (props.titulo !== undefined) {
    return props.titulo;
  }
  return I18n.t('Estructura_escolar');
});

const columnasContenedor = ref(null);

watch(() => props.columnas, async () => {
  await nextTick();
  if (columnasContenedor.value) {
    columnasContenedor.value.scrollLeft = columnasContenedor.value.scrollWidth;
  }
});
</script>

<template>
  <ModalSimple
    :model-value="modelValue"
    :titulo="tituloModal"
    :autofocus="false"
    tamano="lg"
    :nivel-modal="nivelModal"
    :altura-completa="true"
    class="modal-tamano-estructura"
    @update:model-value="emit('update:modelValue', $event)"
  >
    <template #modalBody>
      <div class="modal-body selector-modal-body">
        <Spinner v-if="loading" class="modal-loading" :label="`${$t('cargando')}...`" />
        <template v-else>
          <div v-if="!columnas.length" class="sin-opciones">
            No hay estructura disponible para los filtros actuales.
          </div>
          <div ref="columnasContenedor" class="columnas-visor">
            <transition-group
              name="columna"
              tag="div"
              class="columnas-inner"
            >
              <SelectorColumna
                v-for="(col, index) in columnas"
                :key="col.type"
                :columna="col"
                :is-ultima="index === columnas.length - 1"
                @seleccionar="({ item, tipo }) => emit('seleccionar', { item, tipo, index })"
              />
            </transition-group>
          </div>
        </template>

        <div v-if="!loading" class="modal-footer">
          <button
            type="button"
            class="btn btn-default pull-left"
            :disabled="!puedeLimpiar"
            @click="emit('limpiar')"
          >
            <i class="fa fa-eraser"></i> {{ $t('Limpiar') }}
          </button>
          <button type="button" class="btn btn-default" @click="emit('update:modelValue', false)">
            {{ $t('Cerrar') }}
          </button>
          <button
            type="button"
            class="btn btn-cifra"
            :disabled="!puedeAceptar"
            @click="emit('aceptar')"
          >
            {{ $t('Seleccionar') }}
          </button>
        </div>
      </div>
    </template>
  </ModalSimple>
</template>

<style lang="scss" scoped>
.selector-modal-body {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
}

.columnas-visor {
  overflow-x: auto;
  overflow-y: hidden;
  flex: 1;
  min-height: 0;
}

.columnas-inner {
  display: flex;
  gap: 1rem;
  min-width: max-content;
  height: 100%;
  align-items: stretch;
}

.sin-opciones {
  padding: 1rem;
  color: #6c757d;
  text-align: center;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.18s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}

.columna-enter-active {
  transition: opacity 0.22s ease, transform 0.22s ease;
}

.columna-enter-from {
  opacity: 0;
  transform: translateX(20px);
}

.columna-enter-to {
  opacity: 1;
  transform: translateX(0);
}
</style>
